import cn from 'classnames';

import OPE from 'js/on-page-editing';

import { IEventData } from 'source/NFR.types';

interface IEventDataProps extends IEventData {
  enableTabbing?: boolean;
}

const EventData: React.FC<IEventDataProps> = ({ items = [], onPageEditing, enableTabbing }) => {
  if (!items?.length) return null;

  return (
    <dl className="event-data" {...OPE(onPageEditing?.items)}>
      {items?.map(item => (
        <div
          className={cn('event-data--item', {
            'event-data--item--multiple-paragraphs': item.text[0].length > 1
          })}
          key={item.label}
          tabIndex={enableTabbing ? 0 : -1}
        >
          <dt>{`${item.label}:`}</dt>
          <dd>
            {item.text?.map(paragraphs => (
              <p key={paragraphs[0]}>
                {paragraphs?.map(line => (
                  <span key={line}>{line}</span>
                ))}
              </p>
            ))}
          </dd>
        </div>
      ))}
    </dl>
  );
};

EventData.displayName = 'EventData';

export default EventData;
